import React, { useEffect, useState } from 'react'


const alphabet = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];

let checkResponse = false
export const QuestionCardV3 = ({
	data = {
		question: "",
		img: "",
		options: [
			{
				id: 1,
				text: ""
			},
			{
				id: 2,
				text: "",
				isCorrect: true
			},
			{
				id: 3,
				text: ""
			},
		]
	},
	actionGameQuestion = () => {

	} }) => {
	const [selectAnswer, setSelectAnswer] = useState(-1)
	const [isNextQuestion, setIsNextQuestion] = useState(false)
	const [statusResponse, setStatusResponse] = useState(0)

	const setSelectQuestion = (id) => {
		const questionIsCorrect = data.options.find((opt) => opt.id === id)
		if (!questionIsCorrect) {
			return
		}
		if (checkResponse) {
			return
		}
		checkResponse = true
		if (questionIsCorrect.isCorrect) {
			setStatusResponse(1)
		} else {
			setStatusResponse(2)
		}
		setSelectAnswer(id)
		setIsNextQuestion(true)
	}

	const nextQuestion = () => {
		checkResponse = false
		actionGameQuestion(statusResponse)
		setSelectAnswer(-1)
		setStatusResponse(0)
		setIsNextQuestion(false)
	}

	useEffect(() => {
		let time = null
		if (isNextQuestion) {
			setTimeout(() => {
				nextQuestion()
			}, 1000);
		}
		return () => {
			clearTimeout(time)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isNextQuestion])

	return (
		<>
			<div className='fixed z-20 w-full h-full bottom-0 animate__animated  animate__fadeIn flex items-center justify-center'>
				<div className="min-h-[225px] md:h-[406px] w-[555px] md:w-[940px] gradiantBlueClient flex flex-col justify-center items-center border rounded-[18px] md:rounded-[36px] p-3 md:p-5">
					<div className='w-full flex justify-center items-center mb-2 md:mb-5'>
						<div className="w-full min-h-[48px] md:h-[80px] bg-red_primary rounded-[14px] flex justify-center items-center py-2 md:py-4 px-3 md:px-5">
							<p className="text-white text-[14px] md:text-[16px] md:font-semibold">{data.question}</p>
						</div>
					</div>
					<div className="w-full min-h-[164px] max-h-[300px] h-full flex justify-center items-center">
						<div className="w-full h-full flex justify-center items-center">
							<div className=' w-3/4 flex justify-center items-center'>
								<div className='h-full w-[196px] md:w-[332px] '>
									<img className='h-full max-h-[280px] w-full object-contain object-top' src={data.img} alt="images" />
								</div>
							</div>
							<div className='h-full min-h-[164px] max-h-[300px] w-full grid grid-rows-3 grid-cols-1 justify-between items-center gap-2'>
								{data.options.map((question, index) => (
									<OptionsQuestion
										key={`${index}-questionGame`}
										indexLetter={index}
										selectAnswer={selectAnswer}
										typeResponse={statusResponse}
										action={setSelectQuestion}
										text={question.text}
										id={question.id}
									/>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);

}

const OptionsQuestion = ({ indexLetter = 0, selectAnswer = -1, action = () => { }, text = "", id = 0, typeResponse = 0 }) => {
	let styleQuestion = { back: "bg-white", colorText: "text-black", colorLetter: "text-red_primary" }

	if (typeResponse === 1 && id === selectAnswer) {
		styleQuestion = { back: "bg-[#22C55E]", colorText: "text-white", colorLetter: "text-white" }
	}
	if (typeResponse === 2 && id === selectAnswer) {
		styleQuestion = { back: "bg-[#DF3C3C]", colorText: "text-white", colorLetter: "text-white" }
	}
	return (
		<>
			<div onClick={() => { action(id) }} className={`${styleQuestion.back} w-full h-full rounded-[14px] flex items-center p-2 gap-2 md:gap-4`}  >
				<div className="w-[20px] ">
					<p className={`${styleQuestion.colorLetter} font-bold text-[18px] md:text-[32px]`}>{alphabet[indexLetter]})</p>
				</div>
				<div className="w-[cacl(100%-20px)] overflow-hidden">
					<p className={`${styleQuestion.colorText} font-medium text-[10px] md:text-[14px]`}>{text}</p>
				</div>
			</div>
		</>
	)
}
